export default __webpack_public_path__ + "static/media/home-img3.4cd92213.png";